/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-10-24, 11:29:27
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-22, 12:50:24
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */


import { mapActions } from 'vuex';
import sNumberValidation from '@/services/sNumberValidation';

// CHILD COMPONENTS ////////////////////////////////////////////////////////////
import Card from '@/components/Common/Card';

// COMPONENT ///////////////////////////////////////////////////////////////////
export default {
  name: 'ComplainsForm',

  components: { Card },

  props: ['settings', 'subscriber', 'complainsFormHasBeenSent', 'isLoadingData', 'ccid', 'selectedTile', 'moveToCategory', 'formName'],

  beforeMount() {
    this.setInitialNumber();
  },

  mounted() {
    const { ccid } = this.$route.query;
    if (ccid) this.complainsForm.categoryId = ccid;
  },

  data() {
    return {
      complainsForm: {
        categoryId: '',
        subjectId: '',
        preferredReply: 'e-mail',
        name: null,
        email: null,
        number: null,
        contactHours: '',
        content: '',
      },
      formSubmitRequested: false,
    };
  },

  computed: {
    charactersLeft() {
      return 1000 - this.complainsForm.content.length;
    },
    selectedCategory() {
      if (this.complainsForm.categoryId) {
        return this.settings.complainsCategories
          // eslint-disable-next-line eqeqeq
          .find((obj => obj.id == this.complainsForm.categoryId));
      } return [];
    },
  },

  watch: {
    selectedCategory() {
      const { csid } = this.$route.query;
      if (csid) this.complainsForm.subjectId = csid;
    },
    moveToCategory(newValue) {
      if (newValue !== 0) {
        this.complainsForm.categoryId = newValue;
      }
    },
  },

  methods: {
    ...mapActions(['sendComplainsForm', 'resetComplainsForm']),
    validatePhoneNumber() {
      const number = sNumberValidation.validateNumber(this.complainsForm.number);
      this.complainsForm.number = number;
    },
    isComply() {
      return String(this.selectedCategory.category).toUpperCase().startsWith('REKLAMACJ');
    },
    validateForm() {
      this.$validator.validateAll();
      if (!this.errors.any()) {
        this.formSubmitRequested = true;
        this.sendComplainsForm({
          name: this.complainsForm.name,
          email: this.complainsForm.email,
          contact_hours: this.complainsForm.contactHours,
          preferred_reply: this.isComply() ? this.complainsForm.preferredReply : 'Nie dotyczy',
          content: this.complainsForm.content || '-- Brak treści --',
          contact_number: this.complainsForm.number,
          category_id: this.complainsForm.categoryId,
          subject_id: this.complainsForm.subjectId,
          form_name: this.formName,
        });
      }
    },
    setInitialNumber() {
      this.complainsForm.number = this.subscriber.number;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/Complains/ComplainsForm/component.js